// This file was once generated when you created this area
// but you can edit it freely

import { transformRoutes } from '@backoffice-frontend/common'

const BaseRoadNetworkAreaRoutes = {
  route: '/road-network',
  Index: {
    route: '',
    KeepOutZone: {
      route: '/keep-out-zone',
      Create: {
        route: '/create',
        NewKeepOutZone: {
          route: '/new',
        },
      },
      Details: {
        route: '/:keepOutZoneId',
        Overview: {
          route: '',
          History: {
            route: '/history',
          },
        },
        Activations: {
          route: '/activations',
          Details: {
            route: '/:activationId',
            Delete: {
              route: '/delete',
            },
          },
          New: {
            route: '/new',
          },
        },
        Settings: {
          route: '/settings',
          Edit: {
            route: '/edit',
          },
          Delete: {
            route: '/delete',
          },
        },
      },
    },
    Curb: {
      route: '/curb',
      Create: {
        route: '/create',
        NewRoadBlockage: {
          route: '/new-road-blockage',
        },
      },
      Details: {
        route: '/:curbId',
        Overview: {
          route: '',
          History: {
            route: '/history',
          },
          InvalidateReport: {
            route: '/invalidate-report',
          },
        },
        Activations: {
          route: '/activations',
          Details: {
            route: '/:activationId',
            Delete: {
              route: '/delete',
            },
          },
          New: {
            route: '/new',
          },
        },
        Settings: {
          route: '/settings',
          Edit: {
            route: '/edit',
          },
          Delete: {
            route: '/delete',
          },
        },
        ConvertReportToBlockage: {
          route: '/convert-report-to-blockage',
        },
      },
    },
    TurnRestriction: {
      route: '/turn-restriction',
      Create: {
        route: '/create',
        NewTurnRestriction: {
          route: '/new',
        },
      },
      Details: {
        route: '/:turnRestrictionId',
        Overview: {
          route: '',
          History: {
            route: '/history',
          },
        },
        Activations: {
          route: '/activations',
          Details: {
            route: '/:activationId',
            Delete: {
              route: '/delete',
            },
          },
          New: {
            route: '/new',
          },
        },
        Settings: {
          route: '/settings',
          Edit: {
            route: '/edit',
          },
          Delete: {
            route: '/delete',
          },
        },
      },
    },
  },
}

const removeLeadingSlashes = <T extends Record<string, unknown>>(obj: T): T => {
  const result: Record<string, unknown> = {}
  for (const [key, value] of Object.entries(obj)) {
    if (typeof value === 'string') {
      result[key] = value.replace(/^\//, '')
    } else if (typeof value === 'object' && value !== null) {
      result[key] = removeLeadingSlashes(value as Record<string, unknown>)
    } else {
      result[key] = value
    }
  }
  return result as T
}

// absolute URLs
export const RoadNetworkAreaRoutes = transformRoutes(BaseRoadNetworkAreaRoutes)
// relative paths
export const RoadNetworkAreaSlugs = removeLeadingSlashes(
  BaseRoadNetworkAreaRoutes,
)
